<div class="galleryImage">
  <div class='delete' (click)="deleteImage()" *ngIf="isDeletable()">
    <ion-icon name="close-outline"></ion-icon>
  </div>
  <img src="{{drawing.image}}"/>
</div>